import { useEffect, useState } from 'react';

const PermissionOfMenus = ({
	allowedPermission,
	children,
	checkType = 'SINGLE',
	allowedMultiPermissions = [],
	isRequestForMoreMenu = false,
	customPermissionType
}) => {
	const [menuPermissions, setMenuPermissions] = useState([]);
	const [moreMenuPermissions, setMoreMenuPermissions] = useState([]);

	useEffect(() => {
		let userInfo = localStorage.getItem('userInfo');
		if (userInfo) {
			userInfo = JSON.parse(userInfo);
			setMenuPermissions([...(userInfo?.mainMenus || [])]);
			setMoreMenuPermissions([...(userInfo?.moreMenus || [])]);
		}
	}, []);

	// Check if custom permission type is provided
	if (customPermissionType) {
		try {
			let hasCustomPermission = false;

			if (customPermissionType === 'ADMIN_OR_ACCOUNT_MANAGER') {
				let userInfo = localStorage.getItem('userInfo');
				if (userInfo) {
					userInfo = JSON.parse(userInfo);
					hasCustomPermission =
						userInfo?.primaryUserType === 'ADMIN' ||
						userInfo?.primaryUserType === 'ACCOUNT_MANAGER';
				}
			}
			return hasCustomPermission ? children : null;
		} catch {
			return null;
		}
	}

	if (checkType === 'MULTIPLE') {
		const couldShow = allowedMultiPermissions.every((permission) =>
			isRequestForMoreMenu
				? moreMenuPermissions.includes(permission)
				: menuPermissions.includes(permission)
		);
		return couldShow ? children : null;
	} else {
		const couldShow = isRequestForMoreMenu
			? moreMenuPermissions.includes(allowedPermission)
			: menuPermissions.includes(allowedPermission);
		return couldShow ? children : null;
	}
};

export default PermissionOfMenus;
